import template from './flight-rules-link.html';
import {atcStates} from '../../atc-routes';

const DIRECTIVE_NAME = AtcFlightRulesLink.DIRECTIVE_NAME = 'ktAtcFlightRulesLink';
export default function AtcFlightRulesLink() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: AtcFlightRulesLinkController,
        controllerAs: '$ctrl',
        scope: {
            recommendation: `=${DIRECTIVE_NAME}`,
            fare: `=${DIRECTIVE_NAME}Fare`,
            searchParameters: `=${DIRECTIVE_NAME}SearchParameters`,
            selectedFlights: `=${DIRECTIVE_NAME}SelectedFlights`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function AtcFlightRulesLinkController(
    $window,
    $state,
    userService,
    atcFlightRecommendationService
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        navigateToRulesPage,
    });

    function $onInit() {
    }

    function navigateToRulesPage() {
        const groups = atcFlightRecommendationService
            .getSelectedGroupsInRecommendation(vm.recommendation, vm.selectedFlights)
            .map(({FlightGroupId}) => FlightGroupId);

        const params = {
            groups,
            search: vm.searchParameters.SearchId,
            recommendation: vm.recommendation.RecommendationId,
            fare: vm.fare.FareRecommendationGuid,
            culture: userService.getCulture(),
            adult: getTravellerValue(vm.searchParameters.Travellers.Adult),
            child: getTravellerValue(vm.searchParameters.Travellers.Child),
            infant: getTravellerValue(vm.searchParameters.Travellers.Infant),
        };

        const url = $state.href(atcStates.FLIGHTS_VIEW_RULES, params);
        $window.open(url, '_blank');

        function getTravellerValue(traveller) {
            return traveller
                && (traveller.value || Array.isArray(traveller) && traveller.length)
                || 0;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-rules-link/flight-rules-link-component.js